// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"aa5f495f","136":"76eae076","147":"2abc1b7d","267":"ee03c082","389":"9cf3aa65","416":"c3a9c2c5","482":"8b21bf05","736":"b51274b1","840":"5e7fa3b3","967":"7dcc356b"}[chunkId] + ".chunk.js";
};